import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import AuthorizedLayout from './_routing/layouts/authorized/AuthorizedLayout';
import { examinationActions } from './_store/actions';
import { PostmessageExternalSender } from './_utils';

const App: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const postmessageExternalSender = new PostmessageExternalSender();
    postmessageExternalSender.pageLoaded();
    postmessageExternalSender.pageReady();
  }, []);

  useEffect(() => {
    dispatch(new examinationActions.FetchExamination());
  }, [dispatch]);

  return (
    <Switch>
      <Route component={AuthorizedLayout} path="/" />
      <Redirect to="/" />
    </Switch>
  );
};

export default App;
